import { createAction, props } from "@ngrx/store";
import { SocialVideos } from "./social.state";

export const loadSocialData = createAction(
    '[Social] Load Social data initiated'
);

export const socialDataLoaded = createAction(
    '[Social] Social data loaded',
    props<{
        videos: SocialVideos;
        podcasts: any[];
        accounts: any[];
        posts: any[];
    }>()
);

export const loadSocialError = createAction(
    '[Social] Social data load error',
    props<{
        errorMessage: string
    }>()
);
